<template>
<div id="catalogos_usuarios">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12">
        <base-material-card color="primary" icon="mdi-account" title="Administrar Usuarios" class="elevation-1 px-5 py-3">
          <v-card-actions>
            <v-spacer />

            <v-btn fab dark x-small color="primary" slot="activator" @click.native="agregar" title="Agregar Registro" v-tippy>
              <v-icon dark>add</v-icon>
            </v-btn>
          </v-card-actions>

          <v-card-text>
            <div id="datagrid">
              <v-client-table ref="vuetable" :data="items" :columns="columns" :options="options" class="elevation-2 pa-2">
                <template slot="noResults">
                  <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                </template>

                <template slot="estatus" slot-scope="props">
                  <span v-if="props.row.estatus">Activo</span>
                  <span v-else="props.row.estatus">Inactivo</span>
                </template>

                <template slot="tipo" slot-scope="props">
                  {{props.row.tipo == 1 ? 'Super Administrador': 'Administrador de Empresa'}}
                </template>

                <template slot="actions" slot-scope="props">
                  <v-btn x-small fab dark color="warning" @click.native="desactivar(props.row.uuid, props.row.estatus)" title="Desactivar Usuario" v-tippy>
                      <v-icon>power</v-icon>
                    </v-btn>
                    <v-btn x-small fab dark color="success" @click.native="editar(props.row.uuid)" title="Editar Usuario" v-tippy>
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn x-small fab dark color="pink" @click.native="eliminar(props.row.uuid)" title="Eliminar Usuario" v-tippy>
                      <v-icon>delete</v-icon>
                    </v-btn>
                
                </template>
              </v-client-table>
            </div>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
  <v-dialog v-model="modal" max-width="60%">
    <v-card>
      <v-card-title>
        <span class="headline">{{ tituloModal }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-form ref="form" autocomplete="off">
            <v-card>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-text-field v-model="model.nombre" label="Nombre" :rules="[this.$rules.required]" :autocomplete="false"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" v-if="!this.updateModel">
                    <v-text-field v-model="model.password" label="Password" :rules="[this.$rules.required, this.$rules.password]" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" v-if="!this.updateModel">
                    <v-text-field v-model="password_confirm" label="Confirmar Password" :rules="[this.$rules.required, this.$rules.password, this.valida_iguales]" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :type="show2 ? 'text' : 'password'"
                        @click:append="show2 = !show2"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field v-model="model.email" label="Email" :rules="[this.$rules.required, this.$rules.email]"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field v-model="model.telefono" label="Telefono" :rules="[this.$rules.required]"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-autocomplete v-model="model.tipo" :items="this.$tipo_usuarios.slice(0,2)" :hide-no-data="true" :return-object="false" item-text="text" item-value="value" label="Tipo de Usuario" :rules="[this.$rules.required]"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" v-if="model.tipo == 2">
                    <v-autocomplete v-model="model.uuid_empresa" :items="this.empresas" :hide-no-data="true" :return-object="false" item-text="text" item-value="value" label="Empresa" :rules="[this.$rules.required]"></v-autocomplete>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" small @click="modal=false">
          <v-icon small>mdi-cancel</v-icon> Cancelar
        </v-btn>
        <v-btn color="success" small @click="guardar">
          <v-icon small>mdi-check-circle-outline</v-icon> Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import moment from "moment";

export default {
  created: function() {
    this.URL = this.$hostname + "carta_porte/administracion/";  
    this.model = this.clean_model();    
    this.get_empresas();
    this.cargar();
  },
  computed: {
    tituloModal() {
      return this.updateModel === false ? "Nuevo Usuario" : "Editar Usuario";
    },
  },
  data: () => ({
    URL:"",
    tabla: "usuarios",
    show1: false,
    show2: false,
    modal: false,
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home",
      },
      {
        text: "Usuarios",
        disabled: true,
        href: "",
      },
    ],
    model: {},
    updateModel: false,
    columns: ["nombre", "email", "telefono", "tipo", "estatus", "actions"],
    options: {
      filterable: false,
      headings: {
        nombre: "Nombre",
        email: "Email",
        telefono: "Telefono",
        tipo: "Tipo",
        estatus: "Estatus",
        actions: "Operaciones"
      }
    },
    items: [],
    password_confirm: "",
    empresas: []
  }),
  methods: {
    cargar: function() {
      this.$root.$dialogLoader.show("Espere un momento por favor..");      
      var self = this;
      var params = {
        filtros:{        
          tipo: {"$lt":3},
        }        
      };
      this.$axios.post(this.URL+"list_usuarios/", params)
          .then(res => {
              self.items = res.data;
          })
          .catch(err => {
              this.$swal({
                  type: "error",
                  title: "Error",
                  text: "Ocurrió un error al obtener los registros.",
                  footer: "",
              });
              console.log(err);
          }).then(()=>{              
              self.$root.$dialogLoader.hide();
          });
    
    },
    agregar: function() {
      this.model = this.clean_model();
      this.updateModel = false;
      this.modal = true;
      this.password_confirm = "";
    },
    editar: function(id) {
      this.$root.$dialogLoader.show("Espere un momento por favor..");
      var self = this;
      this.model = this.clean_model();
      var params = {
        filtros: {
          uuid: id,
        },
      };
      this.$axios.post(this.URL+"list_usuarios/", params)
          .then(res => {
            if (typeof res.data !== "undefined") {
               self.model = res.data[0];
               this.modal = true;
               this.updateModel = true;
            }
          })
          .catch(err => {
              this.$swal({
                  type: "error",
                  title: "Error",
                  text: "Ocurrió un error al obtener el registro.",
                  footer: "",
              });
              console.log(err);
          }).then(()=>{              
              self.$root.$dialogLoader.hide();
          });      
      
    },
    desactivar: function(id, estatus) {
      this.$root.$dialogLoader.show("Espere un momento por favor..");
      var self = this;
      var params = {        
          uuid: id,        
          estatus: !estatus,
      };

      this.$axios.post(this.URL+"update_usuario/", params)
          .then(res => {
            self.$swal({
              type: "success",
              title: "¡Operación Exitosa!",
              text: "El registro se guardó correctamente.",
              footer: "",
            });
            self.modal = false;            
          })
          .catch(err => {
              this.$swal({
                  type: "error",
                  title: "Error",
                  text: "Ocurrió un error al guardar el registro.",
                  footer: "",
              });
              console.log(err);
          }).then(()=>{        
              self.cargar();      
              self.$root.$dialogLoader.hide();
          }); 
      
    },
    eliminar: function (id) {      
      var self = this;
      self.$swal({
          type: "info",
          title: "Cuidado",
          text: "¿Está seguro de eliminar el registro?",
          footer: "",
          showCancelButton: true,
          cancelButtonColor: "#d33",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar"
      }).then(result => {
          if (result.value){
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var params = {              
                uuid: id,              
            };
            this.$axios.post(this.URL + "delete_usuario/", params)
              .then(res => {
                  self.$swal({
                    type: "success",
                    title: "¡Operación Exitosa!",
                    text: "El registro se eliminó correctamente.",
                    footer: "",
                  });
                  self.cargar();
              })
              .catch(err => {                        
                  this.$swal({
                      type: "error",
                      title: "Error",
                      text: "Ocurrió un error al eliminar el registro.",
                      footer: "",
                  });
                  console.log(err);
              }).then(()=>{
                  self.$root.$dialogLoader.hide();
              });  
                         
          }
      });
      
    }, 
    guardar: function() {
      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show("Espere un momento por favor..");
        if (this.updateModel === false) {
          this.model.uuid = this.$uuid.v4();
          this.model.creado.usuario = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("nombre_usuario")));
          this.model.creado.fecha = moment().format('YYYY-MM-DD HH:mm:ss');
          this.model.password = this.$crypto.SHA256(this.model.password);

          this.model.uuid_empresa = this.model.tipo === 1 ? "" : this.model.uuid_empresa;
          
          var self = this;
          var search = {
            filtros:{
              email: {"$regex": this.model.email, "$options": 'i'}
            }            
          };

          this.$axios.post(this.URL+"list_usuarios/", search)
          .then(res => {
            
            if (typeof res.data !== "undefined" && res.data.length > 0) {
                self.$swal({
                  type: "error",
                  title: "Error",
                  text: "Ya existe un usuario con ese email.",
                  footer: "",
                });
                self.$root.$dialogLoader.hide();
                self.model.password = '';
                self.password_confirm = "";
              } else {                

                this.$axios.post(this.URL + "create_usuario/", self.model)
                .then(res => {
                    self.$swal({
                      type: "success",
                      title: "¡Operación Exitosa!",
                      text: "El registro se guardó correctamente.",
                      footer: "",
                    });       
                    self.modal = false;             
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al guardar el registro.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{                
                    self.cargar();
                    self.password_confirm = "";
                    self.$root.$dialogLoader.hide();
                }); 
                                
              }
          })
          .catch(err => {
            self.$root.$dialogLoader.hide();
              this.$swal({
                  type: "error",
                  title: "Error",
                  text: "Ocurrió un error al guardar el registro.",
                  footer: "",
              });
              console.log(err);
          });
          

        } else {
          this.model.actualizado.push({
            "usuario": this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("nombre_usuario"))),
            "fecha": moment().format('YYYY-MM-DD HH:mm:ss')
          });

          this.model.uuid_empresa = this.model.tipo === 1 ? "" : this.model.uuid_empresa;
          
          var self = this;
          this.$axios.post(this.URL + "update_usuario/", self.model)
                .then(res => {
                    self.$swal({
                      type: "success",
                      title: "¡Operación Exitosa!",
                      text: "El registro se guardó correctamente.",
                      footer: "",
                    });
                    self.modal = false;                    
                })
                .catch(err => {                        
                    this.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al guardar el registro.",
                        footer: "",
                    });
                    console.log(err);
                }).then(()=>{                
                    self.cargar();
                    self.$root.$dialogLoader.hide();
                    self.password_confirm = "";
                }); 
          
        }        
        
      }
    },
    valida_iguales: function() {
      if (this.password_confirm === this.model.password) {
        return true;
      } else {
        return "La contraseña no coincide";
      }
    },
    get_empresas: function() {
      
      var self = this;
      this.$axios.post(this.URL + "list_empresas/")
          .then(res => {
              if (typeof res.data !== "undefined") {
                  res.data.forEach(function(x){ 
                      self.empresas.push({
                        text: x.nombre,
                        value: x.uuid
                      })
                  })
              }
          })
          .catch(err => {                        
              this.$swal({
                  type: "error",
                  title: "Error",
                  text: "Ocurrió un error al obtener las empresas.",
                  footer: "",
              });
              console.log(err);
          });     
    },
    clean_model: function() {
      return {
        uuid: "",
        nombre: "",
        email: "",
        password: "",
        estatus: true,
        telefono: "",
        tipo: 1,
        uuid_empresa: "",
        uuid_licencia: "",
        permisos: [],
        creado: {
          usuario: "",
          fecha: ""
        },
        actualizado: []
      };
    }
  },
};
</script>
